import { useEffect, useState } from 'react';
import { ProfileTab } from '../../../../../utils/appNavigationNames';
import { useIsFocused } from '@react-navigation/native';

export type UseActiveProfileTabArgs = {
    profileId: string;
    defaultTab?: ProfileTab;
    canViewManageTab: boolean;
};

export type UseActiveProfileTabReturnValue = {
    activeTab: ProfileTab;
    setActiveTab: (tab: ProfileTab) => void;
};

const profileLastTabMap: Record<string, ProfileTab> = {};

export default function useActiveProfileTab({
    profileId,
    defaultTab,
    canViewManageTab,
}: UseActiveProfileTabArgs): UseActiveProfileTabReturnValue {
    const [activeTab, setActiveTab] = useState<ProfileTab>(defaultTab || 'dashboard');
    const isFocused = useIsFocused();
    useEffect(() => {
        if (isFocused) {
            if (defaultTab) {
                setActiveTab(defaultTab);
                return;
            }

            const lastTab = profileLastTabMap[profileId];
            if (!lastTab || (lastTab === 'manage' && !canViewManageTab)) {
                setActiveTab('dashboard');
            } else {
                setActiveTab(lastTab);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused]);

    return {
        activeTab,
        setActiveTab: (activeTab) => {
            profileLastTabMap[profileId] = activeTab;
            setActiveTab(activeTab);
        },
    };
}
